<div class="alert-container">
  <div *ngFor="let alert of alerts(); trackBy: trackByFn"
       class="alert-box"
       [ngClass]="'alert-' + alert.type"
       [class.fade-in]="!alert.fadeOut"
       [class.fade-out]="alert.fadeOut"
       (click)="removeAlert(alert.id)">
    <div class="alert-icon">
      <i [class]="getIcon(alert.type)"></i>
    </div>
    <div class="alert-content">
      {{ alert.message }}
    </div>
    <div class="alert-timer">
      {{ alert.remainingTime }}
    </div>
    <div class="alert-close">
      <i class="fa-solid fa-xmark"></i>
    </div>
  </div>
</div>
